import React, { useContext, useState } from 'react';
import { layoutContext } from '../DORAAssessment';
import SingleOption from './SingleOption';
import './Questions.scss';
import { Button } from 'carbon-components-react';
import { ArrowLeft16, ArrowRight16, Restart16 } from '@carbon/icons-react';
import { Scenario } from '../../data/constants';
import PopUp from '../PopUp/PopUp';

interface questionsProps {
  contents: any;
}

const Questions = (questionsProps: questionsProps) => {
  const { contents } = questionsProps;
  const [questionId, setQuestionId] = useState('q1');
  const {
    setCurrentScenario,
    selectedItems,
    setSelectedItems,
    selectedOption,
  } = useContext(layoutContext);

  const handlePrevious = (qId: string) => {
    setQuestionId(qId);
    setSelectedItems((current: any) => {
      const itemsCopy = { ...current };

      delete itemsCopy[questionId];

      return itemsCopy;
    });
  };
  const handleNext = (qId: string) => {
    if (qId === 'results') {
      return (
        setCurrentScenario(Scenario.results),
        setSelectedItems({
          ...selectedItems,
          [questionId]: selectedOption.optionId,
        })
      );
    } else {
      return (
        setQuestionId(qId),
        setSelectedItems({
          ...selectedItems,
          [questionId]: selectedOption.optionId,
        })
      );
    }
  };
  return (
    <div style={{ margin: 0 }}>
      {contents.map((question: any, i: number) => {
        const questionNumber = i + 1;
        if (question.id === questionId) {
          return (
            <div
              className="bx--row dora-assessment"
              key={questionId}
              style={{
                backgroundImage: `url("${process.env.PUBLIC_ASSETS_URL}/dora-assessment/${question.imageSrc}")`,
              }}
            >
              <div className="bx--col-lg-6 bx--col-md-8 bx--col-sm-4 dora-assessment__question-wrapper">
                <p className="dora-assessment__question-indicator">
                  {questionNumber + '. '}
                  {question.title}
                </p>
                {question.popUp ? <PopUp contents={question.popUp} /> : null}
              </div>
              <div className="bx--col-lg-10 bx--col-md-8 bx--col-sm-4 dora-assessment__answer-wrapper">
                <SingleOption options={question.options} />
                <div className="dora-assessment__question-cta">
                  <Button
                    kind="tertiary"
                    className="dora-assessment__question-cta-previous"
                    onClick={() => setCurrentScenario(Scenario.introduction)}
                  >
                    <Restart16 />
                  </Button>
                  {i > 0 ? (
                    <>
                      <Button
                        kind="tertiary"
                        disabled={i <= 0}
                        className="dora-assessment__question-cta-previous"
                        onClick={() => handlePrevious(contents[i - 1].id)}
                      >
                        <ArrowLeft16 />
                      </Button>
                    </>
                  ) : null}
                  <Button
                    kind="tertiary"
                    disabled={
                      i >= contents.length ||
                      selectedOption.optionId.length === 0 ||
                      selectedOption.nextStep === questionId
                    }
                    className="dora-assessment__question-cta-next"
                    onClick={() => handleNext(selectedOption.nextStep)}
                  >
                    <ArrowRight16 />
                  </Button>
                </div>
              </div>
            </div>
          );
        } else {
          return null;
        }
      })}
    </div>
  );
};

export default Questions;
